import QuestionCard from '../components/QuesAndAns/QuestionCard';
import Filters from '../components/Filters';
import PrimarySearchAppBar from '../components/SearchBar';
import {useEffect, useState} from 'react';
import CreateFAB from '../components/common/CreateFAB';
import Box from '@mui/material/Box';
import DailyLogin from '../components/common/DailyLogin';
import {faker} from '@faker-js/faker';

function Home() {
  const [currentBalance, setCurrentBalance] = useState(faker.number.int({min: 100, max: 1000}));
  useEffect(() => {
    window.scrollTo(0, 0)
  })

  return <Box>
    <PrimarySearchAppBar currentBalance={currentBalance}/>
    <Filters/>
    <DailyLogin currentBalance={currentBalance} onCurrentBalanceUpdate={setCurrentBalance}/>
    <QuestionCard/>
    <CreateFAB/>
  </Box>
}

export default Home
